import React from "react";
import { Badge, Box, Icon, Link, Text } from "~/components-shared";
import { CollapsableTypeEnum, TopicFootprintTypeEnum } from "~/types/enums";
import Markdown from "~/components/Markdown";
import styled from "styled-components";
import Collapsable from "~/components/Collapsable";
import { useTranslation } from "react-i18next";
import FootprintActions from "~/components/FootprintActions";
const Underline = styled.span`
  text-decoration: underline;
`;
const TopicFootprintContentGithub = _ref => {
  let {
    footprint,
    hideDetails = false,
    hideMessage = false
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    actions,
    type,
    data
  } = footprint;
  if ([TopicFootprintTypeEnum.PULL_REQUEST, TopicFootprintTypeEnum.PULL_REQUEST_COMMENT, TopicFootprintTypeEnum.PULL_REQUEST_REVIEW].includes(type)) {
    const {
      prUrl,
      prTitle,
      prDescription,
      repositoryName,
      repositoryUrl,
      prState,
      prLabels,
      prIsDraft,
      prHeadName,
      prBaseName,
      prReviewers
    } = data;
    const draft = prIsDraft ? " (draft)" : "";
    const reviewStates = {
      commented: t("TopicFootprintContentGithub.commented"),
      changes_requested: t("TopicFootprintContentGithub.changesRequested"),
      approved: t("TopicFootprintContentGithub.approved"),
      dismissed: t("TopicFootprintContentGithub.dismissed")
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Github", " ", /*#__PURE__*/React.createElement(Link, {
      href: prUrl,
      underline: true
    }, "pull request"), " ", "on", " ", /*#__PURE__*/React.createElement(Link, {
      href: repositoryUrl,
      underline: true
    }, repositoryName), " ", !!prLabels?.length && /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary"
    }, " ", "labelled with ", /*#__PURE__*/React.createElement(Underline, null, prLabels.join(", "))), !!prReviewers?.length && /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary"
    }, " ", "assigned to", " ", prReviewers.map(reviewer => /*#__PURE__*/React.createElement(Link, {
      key: reviewer.id,
      href: reviewer.url,
      underline: true,
      s: {
        mr: 1
      }
    }, reviewer.name || "login" in reviewer && reviewer.login)))), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6,
      display: "block",
      s: {
        my: 1
      }
    }, prTitle, draft), /*#__PURE__*/React.createElement(Box, {
      gap: 1,
      s: {
        my: 2
      }
    }, /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline",
      s: {
        py: 0.5
      }
    }, prHeadName, " ", /*#__PURE__*/React.createElement(Icon, {
      src: "chevron",
      rotate: 90
    }), " ", prBaseName), /*#__PURE__*/React.createElement(Badge, {
      color: prState === "open" ? "translucentInfo" : data.prIsMerged ? "translucentSuccess" : "translucentDanger",
      display: "inline",
      s: {
        py: 0.5
      }
    }, prState === "open" ? "Open" : data.prIsMerged ? "Merged" : "Closed")), prDescription && /*#__PURE__*/React.createElement(Collapsable, {
      maxHeight: 0,
      type: CollapsableTypeEnum.BUTTON,
      s: {
        mb: 3
      },
      collapsedText: "View PR description",
      expandedText: "Hide PR description"
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: prDescription,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    }))), !hideMessage && "commentId" in data && /*#__PURE__*/React.createElement(Collapsable, {
      s: {
        mb: 1
      }
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: data.commentText,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    })), !hideMessage && "reviewId" in data && /*#__PURE__*/React.createElement(Markdown, {
      text: `**${reviewStates[data.reviewState]}**${data.reviewText ? `: ${data.reviewText}` : ""}`,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    }));
  }
  if ([TopicFootprintTypeEnum.DEPENDABOT_ALERT].includes(type)) {
    const {
      alertState,
      alertUrl,
      alertAdvisoryDescription,
      alertAdvisorySummary,
      alertDependencyPackageName,
      alertDependencyPackageEcosystem,
      repositoryName,
      repositoryUrl
    } = data;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Github", " ", /*#__PURE__*/React.createElement(Link, {
      href: alertUrl,
      underline: true
    }, "dependabot alert"), " ", "on", " ", /*#__PURE__*/React.createElement(Link, {
      href: repositoryUrl,
      underline: true
    }, repositoryName)), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6,
      display: "block",
      s: {
        my: 1
      }
    }, alertAdvisorySummary), /*#__PURE__*/React.createElement(Box, {
      gap: 1,
      s: {
        my: 2
      }
    }, /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline",
      s: {
        py: 0.5
      }
    }, alertDependencyPackageEcosystem, " ", /*#__PURE__*/React.createElement(Icon, {
      src: "chevron",
      rotate: 90
    }), " ", alertDependencyPackageName), /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline",
      s: {
        py: 0.5
      }
    }, alertState)), alertAdvisoryDescription && /*#__PURE__*/React.createElement(Collapsable, {
      maxHeight: 0,
      type: CollapsableTypeEnum.BUTTON,
      s: {
        mb: 3
      },
      collapsedText: "View description",
      expandedText: "Hide description"
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: alertAdvisoryDescription,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    }))));
  }
  if ([TopicFootprintTypeEnum.DEPLOYMENT, TopicFootprintTypeEnum.DEPLOYMENT_STATUS].includes(type)) {
    const {
      deploymentUrl,
      deploymentEnvironment,
      deploymentOriginalEnvironment,
      deploymentDescription,
      deploymentRef,
      repositoryName,
      repositoryUrl
    } = data;
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Github", " ", /*#__PURE__*/React.createElement(Link, {
      href: deploymentUrl,
      underline: true
    }, "deployment"), " ", "on", " ", /*#__PURE__*/React.createElement(Link, {
      href: repositoryUrl,
      underline: true
    }, repositoryName)), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6,
      display: "block",
      s: {
        my: 1
      }
    }, deploymentRef), /*#__PURE__*/React.createElement(Box, {
      gap: 1,
      s: {
        my: 2
      }
    }, /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline",
      s: {
        py: 0.5
      }
    }, deploymentOriginalEnvironment, " ", deploymentEnvironment))), !hideMessage && deploymentDescription && /*#__PURE__*/React.createElement(Collapsable, {
      s: {
        mb: 1
      }
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: deploymentDescription,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    })));
  }
  if ([TopicFootprintTypeEnum.ISSUE, TopicFootprintTypeEnum.ISSUE_COMMENT].includes(type)) {
    const {
      issueTitle,
      issueDescription,
      issueIsDraft,
      issueAssignees,
      issueLabels,
      issueUrl,
      issueState,
      repositoryName,
      repositoryUrl
    } = data;
    const draft = issueIsDraft ? " (draft)" : "";
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Github", " ", /*#__PURE__*/React.createElement(Link, {
      href: issueUrl,
      underline: true
    }, "issue"), " ", "on", " ", /*#__PURE__*/React.createElement(Link, {
      href: repositoryUrl,
      underline: true
    }, repositoryName), " ", !!issueLabels?.length && /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary"
    }, " ", "labelled with ", /*#__PURE__*/React.createElement(Underline, null, issueLabels.join(", "))), !!issueAssignees?.length && /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary"
    }, " ", "assigned to", " ", issueAssignees.map(assignee => /*#__PURE__*/React.createElement(Link, {
      key: assignee.id,
      href: assignee.url,
      underline: true,
      s: {
        mr: 1
      }
    }, assignee.name || assignee.login)))), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6,
      display: "block",
      s: {
        my: 1
      }
    }, issueTitle, draft, /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline",
      s: {
        ml: 2,
        py: 0.5
      }
    }, issueState)), issueDescription && /*#__PURE__*/React.createElement(Collapsable, {
      maxHeight: 0,
      type: CollapsableTypeEnum.BUTTON,
      s: {
        mb: 3
      },
      collapsedText: "View description",
      expandedText: "Hide description"
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: issueDescription,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    }))), !hideMessage && "commentId" in data && /*#__PURE__*/React.createElement(Collapsable, {
      s: {
        mb: 1
      }
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: data.commentText,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    })));
  }
  if ([TopicFootprintTypeEnum.RELEASE].includes(type)) {
    const {
      releaseUrl,
      releaseDescription,
      releaseName,
      releaseIsDraft,
      releaseTagName,
      repositoryName,
      repositoryUrl
    } = data;
    const draft = releaseIsDraft ? " (draft)" : "";
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Github", " ", /*#__PURE__*/React.createElement(Link, {
      href: releaseUrl,
      underline: true
    }, "release"), " ", "on", " ", /*#__PURE__*/React.createElement(Link, {
      href: repositoryUrl,
      underline: true
    }, repositoryName)), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6,
      display: "block",
      s: {
        my: 1
      }
    }, releaseName, draft, " ", /*#__PURE__*/React.createElement(Badge, {
      color: "grey",
      display: "inline",
      s: {
        py: 0.5
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "sell",
      scale: 3,
      s: {
        mr: 1
      }
    }), releaseTagName))), !hideMessage && releaseDescription && /*#__PURE__*/React.createElement(Collapsable, {
      s: {
        mb: 1
      }
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: releaseDescription,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    })));
  }
  if ([TopicFootprintTypeEnum.COMMIT].includes(type)) {
    const {
      pushRef,
      pushIsForced,
      repositoryName,
      headCommitId,
      headCommitMessage,
      headCommitCommiterEmail,
      headCommitCommiterName,
      headCommitCommiterUsername,
      repositoryUrl
    } = data;
    const forced = pushIsForced ? " (forced)" : "";
    return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      display: "block",
      color: "textSecondary",
      weight: "semiBold"
    }, /*#__PURE__*/React.createElement(FootprintActions, {
      actions: actions
    }), " a Github", " ", /*#__PURE__*/React.createElement(Link, {
      href: `${repositoryUrl}/commit/${headCommitId}`,
      underline: true
    }, pushRef.startsWith("refs/tags/") ? "tag" : "commit"), " ", "on", " ", /*#__PURE__*/React.createElement(Link, {
      href: repositoryUrl,
      underline: true
    }, repositoryName)), /*#__PURE__*/React.createElement(Text, {
      weight: "semiBold",
      fontSize: 4.5,
      lineHeight: 6,
      display: "block",
      s: {
        my: 1
      }
    }, pushRef.replace("refs/heads/", "").replace("refs/tags/", ""), forced)), !hideMessage && headCommitMessage && /*#__PURE__*/React.createElement(Collapsable, {
      s: {
        mb: 1
      }
    }, /*#__PURE__*/React.createElement(Markdown, {
      text: headCommitMessage,
      fontSize: 4,
      lineHeight: 6,
      display: "block"
    }), /*#__PURE__*/React.createElement(Text, {
      color: "textSecondary",
      s: {
        mt: 1
      },
      display: "block"
    }, headCommitCommiterName, " (", headCommitCommiterUsername, ") \u2013 ", headCommitCommiterEmail), /*#__PURE__*/React.createElement(Text, null)));
  }
  return /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    weight: "semiBold"
  }, "Unknown event");
};
export default TopicFootprintContentGithub;